import * as React from 'react';
import Typography from '@seeneco-ui/core/components/typography';
import Button from '@seeneco-ui/core/components/button';
import ActionScreen from '@seeneco-ui/core/components/action-screen';
import Box from '@seeneco-ui/core/components/box';
import {
	Form,
	FormTextField,
	FormCopyToClipboardTextField,
} from '@seeneco-ui/core/components/form';
import Spinner from '@seeneco-ui/core/components/spinner';

import {
	FormLayout,
} from './styled';


type ContactDataProps = {
	isFetching: boolean;
	token: OAuthAccessToken;
	onGenerateAccessToken: () => void;
	onRevokeAccessToken: () => void;
};

const DeveloperZone: React.SFC<ContactDataProps> = (props) => {
	const {
		isFetching,
		token,
		onGenerateAccessToken,
		onRevokeAccessToken,
	} = props;

	const renderForm = () => {
		return (
			<Form
				formObject={token}
				isFetching={isFetching}>
				<FormCopyToClipboardTextField
					name='Value'
					label='Токен для использования API'
					appearance='hidden-text'
					setAlwaysValue={token.Value}
					fullWidth
				/>
				<FormTextField
					name='IssueDateTime'
					label='Дата выдачи токена'
					fullWidth
					readonly
				/>
				<FormTextField
					name='ExpireDateTime'
					label='Дата истечения действия токена'
					fullWidth
					readonly
				/>
				<FormTextField
					name='Resource'
					label='Ресурс'
					fullWidth
					readonly
				/>
			</Form>
		);
	};

	return (
		<ActionScreen.Base
			renderHeader={(props) => (
				<ActionScreen.Header {...props}>
					<Typography.Title>Разработчикам</Typography.Title>
				</ActionScreen.Header>
			)}
			renderFooter={() => (
				<ActionScreen.Footer>
					<Button
						disabled={isFetching}
						onClick={onGenerateAccessToken}>
						{token ? 'Сгенерировать новый токен' : 'Сгенерировать токен'}
					</Button>
					{
						token &&
						<Button
							color='default'
							disabled={isFetching}
							onClick={onRevokeAccessToken}>
							Отозвать токен
						</Button>
					}
				</ActionScreen.Footer>
			)}>
			{
				isFetching
				?	<Box
						width='100%'
						minHeight='300px'
						display='flex'
						justifyContent='center'
						alignItems='center'>
						<Spinner />
					</Box>
				: 
				<FormLayout>
					{
						token
						? renderForm()
						: <Box width='100%'>
								<Typography.Label>Для использования API сгенерируйте токен</Typography.Label>
							</Box>
					}
				</FormLayout>
			}
		</ActionScreen.Base>
	);
}

DeveloperZone.displayName = 'DeveloperZone';
DeveloperZone.defaultProps = {};

export default DeveloperZone;
